The request JSON body posted to a webhook endpoint.
